import React from 'react';
import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import { useIsMobile } from '@/hooks/use-mobile';
import InstallPromptContent from './InstallPromptContent';
import { Drawer, DrawerContent } from '@/components/ui/drawer';
import { Dialog, DialogContent } from '@/components/ui/dialog';

export default function InstallPrompt() {
  const { shouldShow, platform, triggerInstall, dismiss } = useInstallPrompt();
  const isMobile = useIsMobile();

  if (!shouldShow) return null;

  const content = (
    <InstallPromptContent
      platform={platform}
      onInstall={triggerInstall}
      onDismiss={dismiss}
    />
  );

  if (isMobile) {
    return (
      <Drawer open={shouldShow} onOpenChange={(open) => { if (!open) dismiss(); }}>
        <DrawerContent className="bg-[#0B0D12] border-[#1E2028]">
          {content}
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={shouldShow} onOpenChange={(open) => { if (!open) dismiss(); }}>
      <DialogContent className="bg-[#0B0D12] border-[#1E2028] sm:max-w-md">
        {content}
      </DialogContent>
    </Dialog>
  );
}
